import BaseTrack from "./basetracks";
//import {getHeaderZFile} from "../zutility/zfile.js"
import { directDownloadBinary } from "../../../../../utils/download.js";

class ZTrack extends BaseTrack
{
    constructor (type, datas, file1, file2, channel, id,parent)
    {
        // track affichage waveform
        super (type, datas, file1, file2, channel, id, parent);
        this.defaultHeight = 40;
        this.minHeight = 40;
        this.maxHeight = 120;

        this.ontopmost = false;
        this.ontop = false;
        this.onbottom = true;
        this.onbottommost = false;
        this.height = this.defaultHeight;

        this.minimisable = true;
        this.minimisedHeight = 24;
        this.fileDownloaded = false;

        var style = getComputedStyle(document.body);
        this.backcolor = style.getPropertyValue('--timeline-waveformtrack-backcolor');        
        //this.headerZ = getHeaderZFile(this.datas);

        this.downloadFile1Done = this.downloadFile1Done.bind(this)
        directDownloadBinary (file1, this.downloadFile1Done, "wf");

    }


    setNewDatas(file, id)
    {
        this.id = id;
        this.file1 = file;
        
        directDownloadBinary (file, this.downloadFile1Done, "wf");
    }

    downloadFile1Done(blob, infos, file)
    {
        this.datas = blob;
        this.fileDownloaded = true;
        

    

    }

    redrawbackgroundLevel1(context, width, currentTime, sTimeCode, starttime, duration,fullheight, ystart)
    {

        if (width <=0) return;
        super.redrawForeGround(context,width);


        
        
     
        var startdrawtime = starttime;
        if (this.fileDownloaded)
        {

        
    
            // une seconde = 240 pixel soit 480 bytes
            var posFichierSon = Math.floor(startdrawtime * 240);
            var largeuraextraire = Math.floor(duration * 240);
            var posFichierFin = posFichierSon + largeuraextraire;
            if (posFichierFin >= this.datas.byteLength)
                posFichierFin = this.datas.byteLength -1;

            //posFichierSon = posFichierSon + this.headerZ.headerSize;
            //posFichierFin = posFichierFin + this.headerZ.headerSize;
            const tempCanvas = document.createElement("canvas");
            tempCanvas.width = largeuraextraire ;
            tempCanvas.height = this.height;
            const tempCtx = tempCanvas.getContext("2d");


            tempCtx.strokeStyle ="red";
            tempCtx.lineWidth = 1;

            var hauteurUtile = this.height - 4;
            var milieu = this.height / 2;            



            var xpos = 0;
            for (var i = posFichierSon; i < posFichierFin; i++)
            {
                var amplitude =  (this.datas[i] * this.height ) /512;
              
                
                tempCtx.beginPath();
                //tempCtx.moveTo(xpos,milieu - value/2);
                //tempCtx.lineTo(xpos,milieu + value/2);

                tempCtx.moveTo(xpos,milieu - amplitude);
                tempCtx.lineTo(xpos,milieu + amplitude) ;

                tempCtx.stroke();
                
                xpos++;

            }
        
            context.drawImage(tempCanvas, 0, this.baseline, width,this.height);
        }
    }
   
}




export default ZTrack;